var _jsxFileName = "/home/runner/work/frontend-shared/frontend-shared/src/components/icons/Show.tsx"; // This file was auto-generated using scripts/generate-icons.js
import { jsxDEV as _jsxDEV } from "preact/jsx-dev-runtime";
/**
 * Icon generated from show.svg
 */
export default function ShowIcon(props) {
  return _jsxDEV("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    "aria-hidden": "true",
    viewBox: "0 0 16 16",
    "data-component": "ShowIcon",
    ...props,
    children: _jsxDEV("path", {
      fill: "currentColor",
      d: "M8 2c4.36 0 8 2.6 8 6s-3.64 6-8 6c-4.36 0-8-2.6-8-6s3.64-6 8-6Zm0 2C4.628 4 2 5.877 2 8s2.628 4 6 4 6-1.877 6-4-2.628-4-6-4Zm0 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z"
    }, void 0, false, {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 7
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName,
    lineNumber: 11,
    columnNumber: 5
  }, this);
}
//# sourceMappingURL=Show.js.map